module.exports = {"231085100":"八面通镇","231085101":"穆棱镇","231085102":"下城子镇","231085103":"马桥河镇","231085104":"兴源镇","231085105":"河西镇","231085200":"福录乡","231085202":"共和乡","231085400":"八面通林业局","231085401":"穆棱林业局"}


//////////////////
// WEBPACK FOOTER
// ./src/town/231085.json
// module id = 880
// module chunks = 0